<template >
    <Moveable
        v-if="rendered"
        class="photoCellImg"
        :class="el.maskImg.isFromSvg ? 'frameWithSvg' : ''"
        :style="el.maskImg.isFromSvg ? stylingSvg : styling"
        @dblclick.native="(e) => handleDbClick(e)"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="handleDragEnd"
        @dragStart="handleDragStart"
        @scale="handleScale"
        @scaleEnd="handleScaleEnd"
        @scaleStart="handleScaleStart"
        ref="photoCellMove"
    >
        <img
            v-if="hasImage"
            style="width: 100%; height: 100%;"
            :src="el.maskImg.src"
        />
        <inline-svg
            v-if="el.maskImg.isFromSvg"
            :src="el.maskImg.src"
            :fill="`#${el.maskImg.color.hex}`"
        />
    </Moveable>
</template>

<script>
    import Moveable from 'vue-moveable';
    export default {
        data() {
            return {
                moveable: {
                    draggable: false,
                    scalable: false,
                    renderDirections: null,
                    keepRatio: true,
                    origin: true,
                    // container: document.getElementById(`editorPhotoCellElement-${this.el.id}`),
                    container: document.getElementById(`${this.$parent.$parent.$parent.parentId}`),
                    className: null,
                    target: '.photoCellImg'
                },
                photoCellEndValues: {
                    width: 0,
                    height: 0
                },
                rendered: false,
                frame: {
                    translate: [-5, -5],
                    scale: [1, 1],
                    rotate: 0
                },
                lastParentScale: [1, 1],
                parentCorners: {
                    leftTop: [0, 0],
                    rightTop: [0, 0],
                    rightBottom: [0, 0],
                    leftBottom: [0, 0]
                },
                childCorners: {
                    leftTop: [0, 0],
                    rightTop: [0, 0],
                    rightBottom: [0, 0],
                    leftBottom: [0, 0]
                },
                oldValue: 0,
                stopScaleX: false,
                stopScaleY: false,
                scalingPoint: undefined
            }
        },
        computed: {
            hasImage() {
                return this.el.maskImg.src !== null && !this.el.maskImg.isFromSvg ? true : false;
            },
            maskImgChange() {
                return this.el.maskImg.src;
            },
            isPhotocellEdited() {
                return this.el.photoCellImageIsEdited;
            },
            styling() {
                return {
                    filter: `blur(${this.el.filters.blur.value}px) brightness(${this.el.filters.brightness.value}%) contrast(${this.el.filters.contrast.value}%) grayscale(${this.el.filters.grayscale.value}%) sepia(${this.el.filters.sepia.value}%)`,
                    width: `${this.el.maskImg.width}px`,
                    height: `${this.el.maskImg.height}px`
                }
            },
            stylingSvg() {
                return {
                    width: `${this.el.maskImg.width}px`,
                    height: `${this.el.maskImg.height}px`
                }
            }
        },
        methods: {
            handleDbClick(e) {
                this.$store.dispatch('UPDATE_ELEMENT', { photoCellImageIsEdited: !this.el.photoCellImageIsEdited })              
                if (this.el.photoCellImageIsEdited === true) {
                    this.$parent.$parent.$parent.$refs.moveable.setState({}, () => {
                        this.$parent.$parent.moveable.draggable = false;
                        this.$parent.$parent.moveable.scalable = false;
                        this.$parent.$parent.moveable.rotatable = false;
                    })
                    this.$parent.$parent.$parent.$refs.moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "none";
                    this.$parent.$parent.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "none";
                    this.$refs.photoCellMove.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "block";
                    this.$refs.photoCellMove.setState({}, () => {
                        this.moveable.draggable = true;
                        this.moveable.scalable = true;
                    })
                } else {
                    this.$parent.$parent.$parent.$refs.moveable.setState({}, () => {
                        this.$parent.$parent.moveable.draggable = true;
                        this.$parent.$parent.moveable.scalable = true;
                        this.$parent.$parent.moveable.rotatable = true;
                    })
                    this.$parent.$parent.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "block";
                    this.$refs.photoCellMove.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "none";
                    this.$refs.photoCellMove.setState({}, () => {
                        this.moveable.draggable = false;
                        this.moveable.scalable = false;
                    })
                }               

            },
            handleDragStart({ set }) {
                set(this.frame.translate);
            },
            handleDrag(args) { 
                const { currentTarget, target, left, top, beforeDelta, transform, beforeTranslate } = args;

                this.frame.translate = beforeTranslate;
                // target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px) scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`;

                currentTarget.updateRect();

                let translateX = beforeTranslate[0];
                let translateY = beforeTranslate[1];

                const childRect = currentTarget.getRect();

                const scalingShiftX = this.el.maskImg.width/2 * (this.frame.scale[0] - 1);
                const maxX = scalingShiftX;
                const minX = -(childRect.width - this.$parent.$parent.$parent.$refs.moveable.getRect().width) * 1 / this.parentFrame.scale[0] + scalingShiftX;

                if (translateX < minX) {
                    translateX = minX;
                } else if (translateX > maxX) {
                    translateX = maxX;
                }

                const scalingShiftY = this.el.maskImg.height/2 * (this.frame.scale[1] - 1);
                const maxY = scalingShiftY;
                const minY = -(childRect.height - this.$parent.$parent.$parent.$refs.moveable.getRect().height) * 1 / this.parentFrame.scale[1] + scalingShiftY;

                if (translateY < minY) {
                    translateY = minY;
                } else if (translateY > maxY) {
                    translateY = maxY;
                }

                this.frame.translate = [translateX, translateY];
                target.style.transform = `translate(${translateX}px, ${translateY}px) scale(${this.frame.scale[0]}, ${this.frame.scale[1]})`;

                
            },
            handleDragEnd ({ currentTarget, target }) {
                currentTarget.updateRect();
                this.$store.dispatch('UPDATE_ELEMENT', {
                    imageFrame: this.frame,
                    imageWebSizeMM: {
                        ...this.el.imageWebSizeMM,
                        translate: [this.frame.translate[0] * 0.084667, this.frame.translate[1] * 0.084667]
                    }
                })
            },

            handleScaleStart({ set, dragStart, inputEvent }) {
                set(this.frame.scale);
                dragStart && dragStart.set(this.frame.translate);
                this.scalingPoint = inputEvent.target.dataset.direction;
            },
            handleScale({ target, transform, scale, currentTarget, delta, drag, clientX, clientY, direction, inputEvent }) {
                currentTarget.updateRect();
                // this.frame.scale = scale;
                // this.frame.translate = drag.beforeTranslate;
                let scaleX = scale[0];
                let scaleY = scale[1];
                let translateX = drag.beforeTranslate[0];
                let translateY = drag.beforeTranslate[1];

                const childRect = currentTarget.getRect();
                const scalingShiftX = this.el.maskImg.width/2 * (this.frame.scale[0] - 1);
                const maxX = scalingShiftX;
                const minX = -(childRect.width - this.$parent.$parent.$parent.$refs.moveable.getRect().width) * 1 / this.parentFrame.scale[0] + scalingShiftX;
                const scalingShiftY = this.el.maskImg.height/2 * (this.frame.scale[1] - 1);
                const maxY = scalingShiftY;
                const minY = -(childRect.height - this.$parent.$parent.$parent.$refs.moveable.getRect().height) * 1 / this.parentFrame.scale[1] + scalingShiftY;

                if (this.scalingPoint === 'nw' || this.scalingPoint === 'sw') {
                    if (translateX > maxX) {
                        translateX = this.frame.translate[0];
                        translateY = this.frame.translate[1];
                        scaleX = this.frame.scale[0]
                        scaleY = this.frame.scale[1]
                    }
                }
                if (this.scalingPoint === 'ne' || this.scalingPoint === 'se') {
                    if (translateX < minX) {
                        translateX = this.frame.translate[0];
                        translateY = this.frame.translate[1];
                        scaleX = this.frame.scale[0]
                        scaleY = this.frame.scale[1]
                    }
                }
                if (this.scalingPoint === 'nw' || this.scalingPoint === 'ne') {
                    if (translateY > maxY) {
                        translateX = this.frame.translate[0];
                        translateY = this.frame.translate[1];
                        scaleX = this.frame.scale[0]
                        scaleY = this.frame.scale[1]
                    }
                }
                if (this.scalingPoint === 'sw' || this.scalingPoint === 'se') {
                    if (translateY < minY) {
                        translateX = this.frame.translate[0];
                        translateY = this.frame.translate[1];
                        scaleX = this.frame.scale[0]
                        scaleY = this.frame.scale[1]
                    }
                }

                this.frame.scale = [scaleX, scaleY];
                this.frame.translate = [translateX, translateY];

                target.style.transform = `translate(${translateX}px, ${translateY}px)` + `scale(${scaleX}, ${scaleY})`;
                
                const width = Math.sqrt(Math.pow(currentTarget.getRect().pos1[0] - currentTarget.getRect().pos2[0], 2) + Math.pow(currentTarget.getRect().pos1[1] - currentTarget.getRect().pos2[1], 2));
                const height = Math.sqrt(Math.pow(currentTarget.getRect().pos2[0] - currentTarget.getRect().pos4[0], 2) + Math.pow(currentTarget.getRect().pos2[1] - currentTarget.getRect().pos4[1], 2));
                this.photoCellEndValues = {
                    ...this.photoCellEndValues,
                    width: width,
                    height: height
                }
            },
            
            handleScaleEnd ({ currentTarget, target }) {

                const width = Math.sqrt(Math.pow(currentTarget.getRect().pos1[0] - currentTarget.getRect().pos2[0], 2) + Math.pow(currentTarget.getRect().pos1[1] - currentTarget.getRect().pos2[1], 2));
                const height = Math.sqrt(Math.pow(currentTarget.getRect().pos2[0] - currentTarget.getRect().pos4[0], 2) + Math.pow(currentTarget.getRect().pos2[1] - currentTarget.getRect().pos4[1], 2));

                currentTarget.updateRect();
                this.$store.dispatch('UPDATE_ELEMENT', {photoCellEndValues: {
                    ...this.photoCellEndValues,
                    width: width,
                    height: height
                }})
                this.$store.dispatch('UPDATE_ELEMENT', {
                    imageFrame: this.frame,
                    imageWebSizeMM: {
                        ...this.el.imageWebSizeMM,
                        translate: [this.frame.translate[0] * 0.084667, this.frame.translate[1] * 0.084667]
                    }
                })
            }
        },
        watch: {
            // parentFrame: {
            //     deep: true,
            //     handler: function() {
            //         if (this.transformDetails.type === 'scale') {
            //             const delta = [(this.parentFrame.scale[0]-this.lastParentScale[0])/this.parentFrame.scale[0], (this.parentFrame.scale[1]-this.lastParentScale[1])/this.parentFrame.scale[1]]
            //             this.frame.scale = [this.frame.scale[0]*(1-delta[0]), this.frame.scale[1]*(1-delta[1])]
            //             this.$el.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`
            //             this.lastParentScale = this.parentFrame.scale;
            //         }

            //         if (this.transformDetails.type === 'rotate') {
            //             this.$el.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${this.frame.scale[0]}, ${this.frame.scale})` + `rotate(${this.frame.rotate-this.parentFrame.rotate}deg)`
            //         }
            //         // this.$refs.photoCellMove.moveable.updateRect();
            //     }
            // },
            transformDetails: {
                deep: true,
                handler: function() {
                    if (this.transformDetails.type === 'scaleEnd') {
                        this.$store.dispatch('UPDATE_ELEMENT', { imageFrame: this.frame })
                    }
                }
            },
            // el: {
            //     deep: true,
            //     handler: function() {
            //         if (this.el.isActive === false) {
            //             this.$store.dispatch('UPDATE_ELEMENT', { photoCellImageIsEdited: false })
            //         } else {
            //             if (this.el.photoCellImageIsEdited === false) {
            //                 this.$refs.photoCellMove.setState({}, () => {
            //                     this.moveable.draggable = false;
            //                     this.moveable.scalable = false;
            //                 })
            //                 this.$parent.$parent.$parent.$refs.moveable.setState({}, () => {
            //                     this.$parent.$parent.moveable.draggable = true;
            //                     this.$parent.$parent.moveable.scalable = true;
            //                     this.$parent.$parent.moveable.rotatable = true;
            //                 })
            //             }
            //         }
                    
            //     }
            // },
            isPhotocellEdited: {
                handler: function() {
                    this.isPhotocellEdited ? (
                        this.$refs.photoCellMove.setState({}, () => {
                            this.moveable.draggable = true;
                            this.moveable.scalable = true;
                        }),
                        this.$refs.photoCellMove.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "block"
                    ) : (
                        this.$refs.photoCellMove.setState({}, () => {
                            this.moveable.draggable = false;
                            this.moveable.scalable = false;
                        }),
                        this.$refs.photoCellMove.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "none"
                    );
                }
            },
            maskImgChange: {
                handler: function() {
                    this.$el.style.width = this.el.maskImg.width + 'px'
                    this.$el.style.height = this.el.maskImg.height + 'px'
                    this.$refs.photoCellMove.updateRect();
                }
            },
            parentFrame: {
                deep: true,
                handler: function() {
                    const parentRect = this.$parent.$parent.$parent.$refs.moveable.getRect();
                    this.parentCorners = {
                        leftTop: parentRect.pos1,
                        rightTop: parentRect.pos2,
                        rightBottom: parentRect.pos4,
                        leftBottom: parentRect.pos3
                    }
                }
            }
        },
        beforeMount() {
            this.moveable.className = `photoCell-${this.el.id}`
            this.moveable.renderDirections = ["nw", "ne", "sw", "se"];
            
        },
        mounted() {
            // this.moveable.container = document.getElementById(`editorPhotoCellElement-${this.el.id}`)
            this.moveable.container = document.getElementById(`${this.$parent.$parent.$parent.parentId}`),
            this.rendered = true;
            if (this.rendered) {
                this.$nextTick(function() {
                    if (this.el.fromProject) {
                        this.$el.style.transform = `translate(${this.el.imageFrame.translate[0]}px, ${this.el.imageFrame.translate[1]}px)` + `scale(${this.el.imageFrame.scale[0]}, ${this.el.imageFrame.scale[1]})` + `rotate(${this.el.imageFrame.rotate}deg)`;
                        this.frame = this.el.imageFrame;
                    } else {

                        this.$el.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`;
                    }
                    this.lastParentScale = this.parentFrame.scale;
                    
                    // this.$el.style.width = this.el.width + 'px'
                    // this.$el.style.height = this.el.height + 'px'
                    this.$refs.photoCellMove.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "none"
                    this.$refs.photoCellMove.updateRect();
                    this.$refs.photoCellMove.moveable.innerMoveable.moveable.moveable.controlBox.element.style.transform = `translate(${this.el.photoCellEndValues.left}px, ${this.el.photoCellEndValues.top}px) translateZ(50px)`
                    const parentRect = this.$parent.$parent.$parent.$refs.moveable.getRect();
                    this.parentCorners = {
                        leftTop: parentRect.pos1,
                        rightTop: parentRect.pos2,
                        rightBottom: parentRect.pos4,
                        leftBottom: parentRect.pos3
                    }
                
                })
            }
        },
        components: {
            Moveable
        },
        props: ['el', 'endValues', 'transformDetails', 'rotate', 'parentFrame']
    }
</script>

<style lang="scss" scoped>
    .editorPhotoCellElement {
        background-color: #8F6E9F;
        position: relative;
    }
    .photoCellImg {
        position: absolute;
        min-width: 210px;
        min-height: 210px;
    }
    .photoCellImg svg {
        width: 100%!important;
        height: 100%!important;
        display: block;
    }
    .frameWithSvg {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>